import { useState } from "react";
import { DefaultPage } from "@on-site/components/pages/default";
import { InvalidPage } from "@on-site/components/pages/invalid";
import { withHelmet } from "@on-site/hoc/withHelmet";
import { withLocalViews } from "@on-site/features/top/hoc/withLocalViews";
import { useLocalViewsStore } from "@on-site/features/top/hooks/useLocalViewsStore";
import { EventConditionPage } from "@on-site/components/pages/eventCondition";

export const TopPage = withHelmet(
  withLocalViews(() => {
    const { localView, setLocalView } = useLocalViewsStore();
    const [patientNo, setPatientNo] = useState("");

    /* 
      NOTE: 以下の2点を考慮し同一URL内で画面切り替えで実装
      1. patientNoを読みとったという前提確認を簡略化するため (URLベースだと読み取りステータスの生合成を取るのが難しい)
      2. 更新時に前患者情報が残ら無いようにするため
    */
    switch (localView) {
      case "EVENT":
        return <EventConditionPage patientNo={patientNo} />;
      case "INVALID":
        return <InvalidPage />;
      case "DEFAULT":
      default:
        return (
          <DefaultPage
            onCheckIn={(patientNo) => {
              setPatientNo(patientNo);
              setLocalView("EVENT");
            }}
          />
        );
    }
  }),
);
